module.exports = __webpack_public_path__ + "static/media/blur-bg.751603f7.png";